import api from "src/shared/api";
import {
  GetAccountsForTransferFromResponse,
  GetBalanceResponse,
  GetAccountsForTransferToResponse,
  TransferPreviewResponse,
  TransferPreviewRequest,
  TransferCreateResponse,
  TransferCreateRequest,
} from "../model/types";

export const transferApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAccountsForTransferFrom: builder.query<
      GetAccountsForTransferFromResponse,
      { clientId: string }
    >({
      query: ({ clientId }) => ({
        url: `/api/erp/clients/${clientId}/accounts/for-transfer/from`,
        method: "GET",
      }),
    }),

    getAccountBalance: builder.query<
      GetBalanceResponse,
      { clientId: string; accountBelongsToClient: number }
    >({
      query: ({ clientId, accountBelongsToClient }) => ({
        url: `/api/clients/${clientId}/accounts/${accountBelongsToClient}/balance`,
        method: "GET",
      }),
    }),

    getAccountsForTransferTo: builder.query<
      GetAccountsForTransferToResponse,
      { clientId: string; accountFromId: number }
    >({
      query: ({ clientId, accountFromId }) => ({
        url: `/api/erp/clients/${clientId}/accounts/for-transfer/to`,
        method: "GET",
        params: {
          account_from_id: accountFromId,
        },
      }),
    }),

    previewTransfer: builder.mutation<
      TransferPreviewResponse,
      { clientId: string; body: TransferPreviewRequest }
    >({
      query: ({ clientId, body }) => ({
        url: `/api/erp/clients/${clientId}/transfers/preview`,
        method: "POST",
        body,
      }),
    }),

    createTransfer: builder.mutation<
      TransferCreateResponse,
      { clientId: string; body: TransferCreateRequest }
    >({
      query: ({ clientId, body }) => ({
        url: `/api/erp/clients/${clientId}/transfers`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetAccountsForTransferFromQuery,
  useLazyGetAccountBalanceQuery,
  useLazyGetAccountsForTransferToQuery,
  usePreviewTransferMutation,
  useCreateTransferMutation,
} = transferApi;
